import kr from '../kr/kr';
import HTMLClass from '../kr/utils/HTMLClass';

export default class CategorySubmenu extends kr.Component {
    init()
    {
        this.$ul = this.$element.querySelector('ul');
        this.scrollMenu();

        let bounce = false;
        window.addEventListener('resize', () => {
            if (bounce) {
                return;
            }
            bounce = true;
            setTimeout(() => {
                this.scrollMenu();
                bounce = false;
            }, 100);
        });
        window.addEventListener('scroll', () => {
            if (bounce) {
                return;
            }
            bounce = true;
            setTimeout(() => {
                this.scrollMenu();
                bounce = false;
            }, 100);
        });
    }

    scrollMenu() {
        if (window.width >= 1025) {
            if(window.scrollY > 210) {
                HTMLClass.addClass(this.$ul, 'menu__visible');
            } else {
                HTMLClass.removeClass(this.$ul, 'menu__visible');
            }
        } else {
            HTMLClass.addClass(this.$ul, 'menu__visible');
        }
    }
}

kr.registerComponent('.site-menu', {
    component: CategorySubmenu
});
